import { Stack } from 'expo-router'
import { useOnetimePayScheduleCardStackScreenProps } from '@/src/experiences/card-payments/screens/OnetimePaySchedule'
import { useOnetimePaymentFundingSourceCardStackScreenProps } from '@/src/experiences/card-payments/screens/OnetimePayFundingSource'
import { useOnetimePayReviewCardStackScreenProps } from '@/src/experiences/card-payments/screens/OnetimePayReview'
import { useOnetimePaySuccessCardStackScreenProps } from '@/src/experiences/card-payments/screens/OnetimePaySuccess'
import { useAutoPayCardStackIndexScreenProps } from '@/src/experiences/card-payments/screens/AutoPaySchedule'
import { useAutoPayFundingSourceScreenProps } from '@/src/experiences/card-payments/screens/AutoPayFundingSource'
import { useAutoPayScheduleReviewScreenProps } from '@/src/experiences/card-payments/screens/AutoPayScheduleReview'
import { useAutoPayReviewScreenProps } from '@/src/experiences/card-payments/screens/AutoPayReview'
import { useAutoPaySuccessScreenProps } from '@/src/experiences/card-payments/screens/AutoPaySuccess'
import {
  useCardManagementStackScreensAreModals,
  useCardStackScreen,
} from '@/src/app/main/(tabs)/card/card-management/_common/cardStackScreen'
import { useAutoPayAgreementScreenProps } from '@/src/experiences/card-payments/screens/AutoPayAgreement'
import { useOneTimePaymentScheduleReviewScreenProps } from '@/src/app/main/(tabs)/card/card-management/payment/oneTimePayment/[id]'

// eslint-disable-next-line
export const unstable_settings = {
  // Ensure that reloading on `/modal` keeps a back button present.
  initialRouteName: 'index',
}

export default function OnTimePayment() {
  return <LayoutNav />
}

function LayoutNav() {
  const cardManagementStackScreensAreModals = useCardManagementStackScreensAreModals()
  return (
    <Stack>
      {useCardStackScreen({
        name: 'index',
        options: {
          title: 'Make a Payment',
          ...(cardManagementStackScreensAreModals
            ? { presentation: 'transparentModal' }
            : undefined),
        },
      }).screen()}

      {useOnetimePayScheduleCardStackScreenProps().screen()}
      {useOnetimePaymentFundingSourceCardStackScreenProps().screen()}
      {useOnetimePayReviewCardStackScreenProps().screen()}
      {useOnetimePaySuccessCardStackScreenProps().screen()}
      {useOneTimePaymentScheduleReviewScreenProps().screen()}

      {useAutoPayCardStackIndexScreenProps().screen()}
      {useAutoPayFundingSourceScreenProps().screen()}
      {useAutoPayScheduleReviewScreenProps().screen()}
      {useAutoPayReviewScreenProps().screen()}
      {useAutoPayAgreementScreenProps().screen()}
      {useAutoPaySuccessScreenProps().screen()}
    </Stack>
  )
}
